(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1695],{

/***/ 41080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ skeleton; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Title.js


/* eslint-disable jsx-a11y/heading-has-content */



var Title = function Title(_ref) {
  var prefixCls = _ref.prefixCls,
      className = _ref.className,
      width = _ref.width,
      style = _ref.style;
  return /*#__PURE__*/react.createElement("h3", {
    className: classnames_default()(prefixCls, className),
    style: (0,esm_extends/* default */.Z)({
      width: width
    }, style)
  });
};

/* harmony default export */ var skeleton_Title = (Title);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(74902);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Paragraph.js




var Paragraph = function Paragraph(props) {
  var getWidth = function getWidth(index) {
    var width = props.width,
        _props$rows = props.rows,
        rows = _props$rows === void 0 ? 2 : _props$rows;

    if (Array.isArray(width)) {
      return width[index];
    } // last paragraph


    if (rows - 1 === index) {
      return width;
    }

    return undefined;
  };

  var prefixCls = props.prefixCls,
      className = props.className,
      style = props.style,
      rows = props.rows;

  var rowList = (0,toConsumableArray/* default */.Z)(Array(rows)).map(function (_, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      react.createElement("li", {
        key: index,
        style: {
          width: getWidth(index)
        }
      })
    );
  });

  return /*#__PURE__*/react.createElement("ul", {
    className: classnames_default()(prefixCls, className),
    style: style
  }, rowList);
};

/* harmony default export */ var skeleton_Paragraph = (Paragraph);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js + 1 modules
var context = __webpack_require__(59844);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Element.js





var Element = function Element(props) {
  var _classNames, _classNames2;

  var prefixCls = props.prefixCls,
      className = props.className,
      style = props.style,
      size = props.size,
      shape = props.shape;
  var sizeCls = classnames_default()((_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames));
  var shapeCls = classnames_default()((_classNames2 = {}, (0,defineProperty/* default */.Z)(_classNames2, "".concat(prefixCls, "-circle"), shape === 'circle'), (0,defineProperty/* default */.Z)(_classNames2, "".concat(prefixCls, "-square"), shape === 'square'), (0,defineProperty/* default */.Z)(_classNames2, "".concat(prefixCls, "-round"), shape === 'round'), _classNames2));
  var sizeStyle = typeof size === 'number' ? {
    width: size,
    height: size,
    lineHeight: "".concat(size, "px")
  } : {};
  return /*#__PURE__*/react.createElement("span", {
    className: classnames_default()(prefixCls, sizeCls, shapeCls, className),
    style: (0,esm_extends/* default */.Z)((0,esm_extends/* default */.Z)({}, sizeStyle), style)
  });
};

/* harmony default export */ var skeleton_Element = (Element);
// EXTERNAL MODULE: ./node_modules/rc-util/es/omit.js
var omit = __webpack_require__(98423);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Avatar.js








var SkeletonAvatar = function SkeletonAvatar(props) {
  var renderSkeletonAvatar = function renderSkeletonAvatar(_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls,
        className = props.className,
        active = props.active;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var otherProps = (0,omit/* default */.Z)(props, ['prefixCls']);
    var cls = classnames_default()(prefixCls, "".concat(prefixCls, "-element"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-active"), active), className);
    return /*#__PURE__*/react.createElement("div", {
      className: cls
    }, /*#__PURE__*/react.createElement(skeleton_Element, (0,esm_extends/* default */.Z)({
      prefixCls: "".concat(prefixCls, "-avatar")
    }, otherProps)));
  };

  return /*#__PURE__*/react.createElement(context/* ConfigConsumer */.C, null, renderSkeletonAvatar);
};

SkeletonAvatar.defaultProps = {
  size: 'default',
  shape: 'circle'
};
/* harmony default export */ var Avatar = (SkeletonAvatar);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Button.js








var SkeletonButton = function SkeletonButton(props) {
  var renderSkeletonButton = function renderSkeletonButton(_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls,
        className = props.className,
        active = props.active;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var otherProps = (0,omit/* default */.Z)(props, ['prefixCls']);
    var cls = classnames_default()(prefixCls, "".concat(prefixCls, "-element"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-active"), active), className);
    return /*#__PURE__*/react.createElement("div", {
      className: cls
    }, /*#__PURE__*/react.createElement(skeleton_Element, (0,esm_extends/* default */.Z)({
      prefixCls: "".concat(prefixCls, "-button")
    }, otherProps)));
  };

  return /*#__PURE__*/react.createElement(context/* ConfigConsumer */.C, null, renderSkeletonButton);
};

SkeletonButton.defaultProps = {
  size: 'default'
};
/* harmony default export */ var Button = (SkeletonButton);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Input.js








var SkeletonInput = function SkeletonInput(props) {
  var renderSkeletonInput = function renderSkeletonInput(_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls,
        className = props.className,
        active = props.active;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var otherProps = (0,omit/* default */.Z)(props, ['prefixCls']);
    var cls = classnames_default()(prefixCls, "".concat(prefixCls, "-element"), (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-active"), active), className);
    return /*#__PURE__*/react.createElement("div", {
      className: cls
    }, /*#__PURE__*/react.createElement(skeleton_Element, (0,esm_extends/* default */.Z)({
      prefixCls: "".concat(prefixCls, "-input")
    }, otherProps)));
  };

  return /*#__PURE__*/react.createElement(context/* ConfigConsumer */.C, null, renderSkeletonInput);
};

SkeletonInput.defaultProps = {
  size: 'default'
};
/* harmony default export */ var Input = (SkeletonInput);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Image.js



var path = 'M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z';

var SkeletonImage = function SkeletonImage(props) {
  var renderSkeletonImage = function renderSkeletonImage(_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls,
        className = props.className,
        style = props.style;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    var cls = classnames_default()(prefixCls, "".concat(prefixCls, "-element"), className);
    return /*#__PURE__*/react.createElement("div", {
      className: cls
    }, /*#__PURE__*/react.createElement("div", {
      className: classnames_default()("".concat(prefixCls, "-image"), className),
      style: style
    }, /*#__PURE__*/react.createElement("svg", {
      viewBox: "0 0 1098 1024",
      xmlns: "http://www.w3.org/2000/svg",
      className: "".concat(prefixCls, "-image-svg")
    }, /*#__PURE__*/react.createElement("path", {
      d: path,
      className: "".concat(prefixCls, "-image-path")
    }))));
  };

  return /*#__PURE__*/react.createElement(context/* ConfigConsumer */.C, null, renderSkeletonImage);
};

/* harmony default export */ var Image = (SkeletonImage);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/Skeleton.js














function getComponentProps(prop) {
  if (prop && (0,esm_typeof/* default */.Z)(prop) === 'object') {
    return prop;
  }

  return {};
}

function getAvatarBasicProps(hasTitle, hasParagraph) {
  if (hasTitle && !hasParagraph) {
    // Square avatar
    return {
      size: 'large',
      shape: 'square'
    };
  }

  return {
    size: 'large',
    shape: 'circle'
  };
}

function getTitleBasicProps(hasAvatar, hasParagraph) {
  if (!hasAvatar && hasParagraph) {
    return {
      width: '38%'
    };
  }

  if (hasAvatar && hasParagraph) {
    return {
      width: '50%'
    };
  }

  return {};
}

function getParagraphBasicProps(hasAvatar, hasTitle) {
  var basicProps = {}; // Width

  if (!hasAvatar || !hasTitle) {
    basicProps.width = '61%';
  } // Rows


  if (!hasAvatar && hasTitle) {
    basicProps.rows = 3;
  } else {
    basicProps.rows = 2;
  }

  return basicProps;
}

var Skeleton = function Skeleton(props) {
  var renderSkeleton = function renderSkeleton(_ref) {
    var getPrefixCls = _ref.getPrefixCls,
        direction = _ref.direction;
    var customizePrefixCls = props.prefixCls,
        loading = props.loading,
        className = props.className,
        children = props.children,
        avatar = props.avatar,
        title = props.title,
        paragraph = props.paragraph,
        active = props.active,
        round = props.round;
    var prefixCls = getPrefixCls('skeleton', customizePrefixCls);

    if (loading || !('loading' in props)) {
      var _classNames;

      var hasAvatar = !!avatar;
      var hasTitle = !!title;
      var hasParagraph = !!paragraph; // Avatar

      var avatarNode;

      if (hasAvatar) {
        var avatarProps = (0,esm_extends/* default */.Z)((0,esm_extends/* default */.Z)({
          prefixCls: "".concat(prefixCls, "-avatar")
        }, getAvatarBasicProps(hasTitle, hasParagraph)), getComponentProps(avatar)); // We direct use SkeletonElement as avatar in skeleton internal.


        avatarNode = /*#__PURE__*/react.createElement("div", {
          className: "".concat(prefixCls, "-header")
        }, /*#__PURE__*/react.createElement(skeleton_Element, avatarProps));
      }

      var contentNode;

      if (hasTitle || hasParagraph) {
        // Title
        var $title;

        if (hasTitle) {
          var titleProps = (0,esm_extends/* default */.Z)((0,esm_extends/* default */.Z)({
            prefixCls: "".concat(prefixCls, "-title")
          }, getTitleBasicProps(hasAvatar, hasParagraph)), getComponentProps(title));

          $title = /*#__PURE__*/react.createElement(skeleton_Title, titleProps);
        } // Paragraph


        var paragraphNode;

        if (hasParagraph) {
          var paragraphProps = (0,esm_extends/* default */.Z)((0,esm_extends/* default */.Z)({
            prefixCls: "".concat(prefixCls, "-paragraph")
          }, getParagraphBasicProps(hasAvatar, hasTitle)), getComponentProps(paragraph));

          paragraphNode = /*#__PURE__*/react.createElement(skeleton_Paragraph, paragraphProps);
        }

        contentNode = /*#__PURE__*/react.createElement("div", {
          className: "".concat(prefixCls, "-content")
        }, $title, paragraphNode);
      }

      var cls = classnames_default()(prefixCls, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-with-avatar"), hasAvatar), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-active"), active), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-round"), round), _classNames), className);
      return /*#__PURE__*/react.createElement("div", {
        className: cls
      }, avatarNode, contentNode);
    }

    return children;
  };

  return /*#__PURE__*/react.createElement(context/* ConfigConsumer */.C, null, renderSkeleton);
};

Skeleton.defaultProps = {
  avatar: false,
  title: true,
  paragraph: true
};
Skeleton.Button = Button;
Skeleton.Avatar = Avatar;
Skeleton.Input = Input;
Skeleton.Image = Image;
/* harmony default export */ var skeleton_Skeleton = (Skeleton);
;// CONCATENATED MODULE: ./node_modules/antd/es/skeleton/index.js

/* harmony default export */ var skeleton = (skeleton_Skeleton);

/***/ }),

/***/ 13882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 42699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isAfter; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19013);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var dateToCompare = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),

/***/ 19013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13882);

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),

/***/ 29932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 21078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isFlattenable = __webpack_require__(37285);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 23933:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),

/***/ 80531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    arrayMap = __webpack_require__(29932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 37285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 3522:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(79833);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

module.exports = escapeRegExp;


/***/ }),

/***/ 85564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 96347:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(23933),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),

/***/ 47037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isArray = __webpack_require__(1469),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 79833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 28874:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * @license
 *
 * Push v1.0.9
 * =========
 * A compact, cross-browser solution for the JavaScript Notifications API
 *
 * Credits
 * -------
 * Tsvetan Tsvetkov (ttsvetko)
 * Alex Gibson (alexgibson)
 *
 * License
 * -------
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2015-2017 Tyler Nickerson
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
!function(i,t){ true?module.exports=t():0}(this,function(){"use strict";var i={errors:{incompatible:"".concat("PushError:"," Push.js is incompatible with browser."),invalid_plugin:"".concat("PushError:"," plugin class missing from plugin manifest (invalid plugin). Please check the documentation."),invalid_title:"".concat("PushError:"," title of notification must be a string"),permission_denied:"".concat("PushError:"," permission request declined"),sw_notification_error:"".concat("PushError:"," could not show a ServiceWorker notification due to the following reason: "),sw_registration_error:"".concat("PushError:"," could not register the ServiceWorker due to the following reason: "),unknown_interface:"".concat("PushError:"," unable to create notification: unknown interface")}};function t(i){return(t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(i){return typeof i}:function(i){return i&&"function"==typeof Symbol&&i.constructor===Symbol&&i!==Symbol.prototype?"symbol":typeof i})(i)}function n(i,t){if(!(i instanceof t))throw new TypeError("Cannot call a class as a function")}function e(i,t){for(var n=0;n<t.length;n++){var e=t[n];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(i,e.key,e)}}function o(i,t,n){return t&&e(i.prototype,t),n&&e(i,n),i}function r(i,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");i.prototype=Object.create(t&&t.prototype,{constructor:{value:i,writable:!0,configurable:!0}}),t&&c(i,t)}function s(i){return(s=Object.setPrototypeOf?Object.getPrototypeOf:function(i){return i.__proto__||Object.getPrototypeOf(i)})(i)}function c(i,t){return(c=Object.setPrototypeOf||function(i,t){return i.__proto__=t,i})(i,t)}function a(i,t){return!t||"object"!=typeof t&&"function"!=typeof t?function(i){if(void 0===i)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return i}(i):t}var u=function(){function i(t){n(this,i),this._win=t,this.GRANTED="granted",this.DEFAULT="default",this.DENIED="denied",this._permissions=[this.GRANTED,this.DEFAULT,this.DENIED]}return o(i,[{key:"request",value:function(i,t){return arguments.length>0?this._requestWithCallback.apply(this,arguments):this._requestAsPromise()}},{key:"_requestWithCallback",value:function(i,t){var n,e=this,o=this.get(),r=!1,s=function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:e._win.Notification.permission;r||(r=!0,void 0===n&&e._win.webkitNotifications&&(n=e._win.webkitNotifications.checkPermission()),n===e.GRANTED||0===n?i&&i():t&&t())};o!==this.DEFAULT?s(o):this._win.webkitNotifications&&this._win.webkitNotifications.checkPermission?this._win.webkitNotifications.requestPermission(s):this._win.Notification&&this._win.Notification.requestPermission?(n=this._win.Notification.requestPermission(s))&&n.then&&n.then(s).catch(function(){t&&t()}):i&&i()}},{key:"_requestAsPromise",value:function(){var i=this,t=this.get(),n=t!==this.DEFAULT,e=this._win.Notification&&this._win.Notification.requestPermission,o=this._win.webkitNotifications&&this._win.webkitNotifications.checkPermission;return new Promise(function(r,s){var c,a=!1,u=function(t){a||(a=!0,!function(t){return t===i.GRANTED||0===t}(t)?s():r())};n?u(t):o?i._win.webkitNotifications.requestPermission(function(i){u(i)}):e?(c=i._win.Notification.requestPermission(u))&&c.then&&c.then(u).catch(s):r()})}},{key:"has",value:function(){return this.get()===this.GRANTED}},{key:"get",value:function(){return this._win.Notification&&this._win.Notification.permission?this._win.Notification.permission:this._win.webkitNotifications&&this._win.webkitNotifications.checkPermission?this._permissions[this._win.webkitNotifications.checkPermission()]:navigator.mozNotification?this.GRANTED:this._win.external&&this._win.external.msIsSiteMode?this._win.external.msIsSiteMode()?this.GRANTED:this.DEFAULT:this.GRANTED}}]),i}(),f=function(){function i(){n(this,i)}return o(i,null,[{key:"isUndefined",value:function(i){return void 0===i}},{key:"isNull",value:function(i){return null===obj}},{key:"isString",value:function(i){return"string"==typeof i}},{key:"isFunction",value:function(i){return i&&"[object Function]"==={}.toString.call(i)}},{key:"isObject",value:function(i){return"object"===t(i)}},{key:"objectMerge",value:function(i,t){for(var n in t)i.hasOwnProperty(n)&&this.isObject(i[n])&&this.isObject(t[n])?this.objectMerge(i[n],t[n]):i[n]=t[n]}}]),i}(),l=function i(t){n(this,i),this._win=t},h=function(i){function t(){return n(this,t),a(this,s(t).apply(this,arguments))}return r(t,l),o(t,[{key:"isSupported",value:function(){return void 0!==this._win.Notification}},{key:"create",value:function(i,t){return new this._win.Notification(i,{icon:f.isString(t.icon)||f.isUndefined(t.icon)||f.isNull(t.icon)?t.icon:t.icon.x32,body:t.body,tag:t.tag,requireInteraction:t.requireInteraction})}},{key:"close",value:function(i){i.close()}}]),t}(),_=function(t){function e(){return n(this,e),a(this,s(e).apply(this,arguments))}return r(e,l),o(e,[{key:"isSupported",value:function(){return void 0!==this._win.navigator&&void 0!==this._win.navigator.serviceWorker}},{key:"getFunctionBody",value:function(i){var t=i.toString().match(/function[^{]+{([\s\S]*)}$/);return null!=t&&t.length>1?t[1]:null}},{key:"create",value:function(t,n,e,o,r){var s=this;this._win.navigator.serviceWorker.register(o),this._win.navigator.serviceWorker.ready.then(function(o){var c={id:t,link:e.link,origin:document.location.href,onClick:f.isFunction(e.onClick)?s.getFunctionBody(e.onClick):"",onClose:f.isFunction(e.onClose)?s.getFunctionBody(e.onClose):""};void 0!==e.data&&null!==e.data&&(c=Object.assign(c,e.data)),o.showNotification(n,{icon:e.icon,body:e.body,vibrate:e.vibrate,tag:e.tag,data:c,requireInteraction:e.requireInteraction,silent:e.silent}).then(function(){o.getNotifications().then(function(i){o.active.postMessage(""),r(i)})}).catch(function(t){throw new Error(i.errors.sw_notification_error+t.message)})}).catch(function(t){throw new Error(i.errors.sw_registration_error+t.message)})}},{key:"close",value:function(){}}]),e}(),v=function(i){function t(){return n(this,t),a(this,s(t).apply(this,arguments))}return r(t,l),o(t,[{key:"isSupported",value:function(){return void 0!==this._win.navigator.mozNotification}},{key:"create",value:function(i,t){var n=this._win.navigator.mozNotification.createNotification(i,t.body,t.icon);return n.show(),n}}]),t}(),d=function(i){function t(){return n(this,t),a(this,s(t).apply(this,arguments))}return r(t,l),o(t,[{key:"isSupported",value:function(){return void 0!==this._win.external&&void 0!==this._win.external.msIsSiteMode}},{key:"create",value:function(i,t){return this._win.external.msSiteModeClearIconOverlay(),this._win.external.msSiteModeSetIconOverlay(f.isString(t.icon)||f.isUndefined(t.icon)?t.icon:t.icon.x16,i),this._win.external.msSiteModeActivate(),null}},{key:"close",value:function(){this._win.external.msSiteModeClearIconOverlay()}}]),t}(),w=function(i){function t(){return n(this,t),a(this,s(t).apply(this,arguments))}return r(t,l),o(t,[{key:"isSupported",value:function(){return void 0!==this._win.webkitNotifications}},{key:"create",value:function(i,t){var n=this._win.webkitNotifications.createNotification(t.icon,i,t.body);return n.show(),n}},{key:"close",value:function(i){i.cancel()}}]),t}();return new(function(){function t(i){n(this,t),this._currentId=0,this._notifications={},this._win=i,this.Permission=new u(i),this._agents={desktop:new h(i),chrome:new _(i),firefox:new v(i),ms:new d(i),webkit:new w(i)},this._configuration={serviceWorker:"/serviceWorker.min.js",fallback:function(i){}}}return o(t,[{key:"_closeNotification",value:function(t){var n=!0,e=this._notifications[t];if(void 0!==e){if(n=this._removeNotification(t),this._agents.desktop.isSupported())this._agents.desktop.close(e);else if(this._agents.webkit.isSupported())this._agents.webkit.close(e);else{if(!this._agents.ms.isSupported())throw n=!1,new Error(i.errors.unknown_interface);this._agents.ms.close()}return n}return!1}},{key:"_addNotification",value:function(i){var t=this._currentId;return this._notifications[t]=i,this._currentId++,t}},{key:"_removeNotification",value:function(i){var t=!1;return this._notifications.hasOwnProperty(i)&&(delete this._notifications[i],t=!0),t}},{key:"_prepareNotification",value:function(i,t){var n,e=this;return n={get:function(){return e._notifications[i]},close:function(){e._closeNotification(i)}},t.timeout&&setTimeout(function(){n.close()},t.timeout),n}},{key:"_serviceWorkerCallback",value:function(i,t,n){var e=this,o=this._addNotification(i[i.length-1]);navigator&&navigator.serviceWorker&&(navigator.serviceWorker.addEventListener("message",function(i){var t=JSON.parse(i.data);"close"===t.action&&Number.isInteger(t.id)&&e._removeNotification(t.id)}),n(this._prepareNotification(o,t))),n(null)}},{key:"_createCallback",value:function(i,t,n){var e,o=this,r=null;if(t=t||{},e=function(i){o._removeNotification(i),f.isFunction(t.onClose)&&t.onClose.call(o,r)},this._agents.desktop.isSupported())try{r=this._agents.desktop.create(i,t)}catch(e){var s=this._currentId,c=this.config().serviceWorker;this._agents.chrome.isSupported()&&this._agents.chrome.create(s,i,t,c,function(i){return o._serviceWorkerCallback(i,t,n)})}else this._agents.webkit.isSupported()?r=this._agents.webkit.create(i,t):this._agents.firefox.isSupported()?this._agents.firefox.create(i,t):this._agents.ms.isSupported()?r=this._agents.ms.create(i,t):(t.title=i,this.config().fallback(t));if(null!==r){var a=this._addNotification(r),u=this._prepareNotification(a,t);f.isFunction(t.onShow)&&r.addEventListener("show",t.onShow),f.isFunction(t.onError)&&r.addEventListener("error",t.onError),f.isFunction(t.onClick)&&r.addEventListener("click",t.onClick),r.addEventListener("close",function(){e(a)}),r.addEventListener("cancel",function(){e(a)}),n(u)}n(null)}},{key:"create",value:function(t,n){var e,o=this;if(!f.isString(t))throw new Error(i.errors.invalid_title);return e=this.Permission.has()?function(i,e){try{o._createCallback(t,n,i)}catch(i){e(i)}}:function(e,r){o.Permission.request().then(function(){o._createCallback(t,n,e)}).catch(function(){r(i.errors.permission_denied)})},new Promise(e)}},{key:"count",value:function(){var i,t=0;for(i in this._notifications)this._notifications.hasOwnProperty(i)&&t++;return t}},{key:"close",value:function(i){var t;for(t in this._notifications)if(this._notifications.hasOwnProperty(t)&&this._notifications[t].tag===i)return this._closeNotification(t)}},{key:"clear",value:function(){var i,t=!0;for(i in this._notifications)this._notifications.hasOwnProperty(i)&&(t=t&&this._closeNotification(i));return t}},{key:"supported",value:function(){var i=!1;for(var t in this._agents)this._agents.hasOwnProperty(t)&&(i=i||this._agents[t].isSupported());return i}},{key:"config",value:function(i){return(void 0!==i||null!==i&&f.isObject(i))&&f.objectMerge(this._configuration,i),this._configuration}},{key:"extend",value:function(t){var n,e={}.hasOwnProperty;if(!e.call(t,"plugin"))throw new Error(i.errors.invalid_plugin);for(var o in e.call(t,"config")&&f.isObject(t.config)&&null!==t.config&&this.config(t.config),n=new(0,t.plugin)(this.config()))e.call(n,o)&&f.isFunction(n[o])&&(this[o]=n[o])}}]),t}())("undefined"!=typeof window?window:__webpack_require__.g)});
//# sourceMappingURL=push.min.js.map


/***/ }),

/***/ 98423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ omit; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1413);

function omit(obj, fields) {
  var clone = (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, obj);

  if (Array.isArray(fields)) {
    fields.forEach(function (key) {
      delete clone[key];
    });
  }

  return clone;
}

/***/ }),

/***/ 75164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ wrapperRaf; }
/* harmony export */ });
var raf = function raf(callback) {
  return +setTimeout(callback, 16);
};

var caf = function caf(num) {
  return clearTimeout(num);
};

if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
  raf = function raf(callback) {
    return window.requestAnimationFrame(callback);
  };

  caf = function caf(handle) {
    return window.cancelAnimationFrame(handle);
  };
}

var rafUUID = 0;
var rafIds = new Map();

function cleanup(id) {
  rafIds.delete(id);
}

function wrapperRaf(callback) {
  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;

  function callRef(leftTimes) {
    if (leftTimes === 0) {
      // Clean up
      cleanup(id); // Trigger

      callback();
    } else {
      // Next raf
      var realId = raf(function () {
        callRef(leftTimes - 1);
      }); // Bind real raf id

      rafIds.set(id, realId);
    }
  }

  callRef(times);
  return id;
}

wrapperRaf.cancel = function (id) {
  var realId = rafIds.get(id);
  cleanup(realId);
  return caf(realId);
};

/***/ }),

/***/ 42550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yr": function() { return /* binding */ supportRef; },
/* harmony export */   "mH": function() { return /* binding */ fillRef; },
/* harmony export */   "sQ": function() { return /* binding */ composeRef; }
/* harmony export */ });
/* unused harmony export useComposeRef */
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71002);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59864);
/* harmony import */ var _hooks_useMemo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56982);



function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}
/**
 * Merge refs into one ref function to support ref passing.
 */

function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  var refList = refs.filter(function (ref) {
    return ref;
  });

  if (refList.length <= 1) {
    return refList[0];
  }

  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
}
function useComposeRef() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }

  return useMemo(function () {
    return composeRef.apply(void 0, refs);
  }, refs, function (prev, next) {
    return prev.length === next.length && prev.every(function (ref, i) {
      return ref === next[i];
    });
  });
}
function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;

  var type = (0,react_is__WEBPACK_IMPORTED_MODULE_0__.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type; // Function component node

  if (typeof type === 'function' && !((_type$prototype = type.prototype) === null || _type$prototype === void 0 ? void 0 : _type$prototype.render)) {
    return false;
  } // Class component


  if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) === null || _nodeOrComponent$prot === void 0 ? void 0 : _nodeOrComponent$prot.render)) {
    return false;
  }

  return true;
}
/* eslint-enable */

/***/ }),

/***/ 59632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable vars-on-top, no-var, prefer-template */
var isRegExp = __webpack_require__(96347);
var escapeRegExp = __webpack_require__(3522);
var isString = __webpack_require__(47037);
var flatten = __webpack_require__(85564);

/**
 * Given a string, replace every substring that is matched by the `match` regex
 * with the result of calling `fn` on matched substring. The result will be an
 * array with all odd indexed elements containing the replacements. The primary
 * use case is similar to using String.prototype.replace except for React.
 *
 * React will happily render an array as children of a react element, which
 * makes this approach very useful for tasks like surrounding certain text
 * within a string with react elements.
 *
 * Example:
 * matchReplace(
 *   'Emphasize all phone numbers like 884-555-4443.',
 *   /([\d|-]+)/g,
 *   (number, i) => <strong key={i}>{number}</strong>
 * );
 * // => ['Emphasize all phone numbers like ', <strong>884-555-4443</strong>, '.'
 *
 * @param {string} str
 * @param {regexp|str} match Must contain a matching group
 * @param {function} fn
 * @return {array}
 */
function replaceString(str, match, fn) {
  var curCharStart = 0;
  var curCharLen = 0;

  if (str === '') {
    return str;
  } else if (!str || !isString(str)) {
    throw new TypeError('First argument to react-string-replace#replaceString must be a string');
  }

  var re = match;

  if (!isRegExp(re)) {
    re = new RegExp('(' + escapeRegExp(re) + ')', 'gi');
  }

  var result = str.split(re);

  // Apply fn to all odd elements
  for (var i = 1, length = result.length; i < length; i += 2) {
    curCharLen = result[i].length;
    curCharStart += result[i - 1].length;
    result[i] = fn(result[i], i, curCharStart);
    curCharStart += curCharLen;
  }

  return result;
}

module.exports = function reactStringReplace(source, match, fn) {
  if (!Array.isArray(source)) source = [source];

  return flatten(source.map(function(x) {
    return isString(x) ? replaceString(x, match, fn) : x;
  }));
};


/***/ }),

/***/ 4384:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "vC": function() { return /* binding */ WebsocketRequest; },
  "XC": function() { return /* binding */ websocket_pb_WebsocketResponse; }
});

// UNUSED EXPORTS: WebsocketRequest_Request, WebsocketRequest_Request_Channel, WebsocketRequest_Request_Command

// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/proto3.js + 19 modules
var esm_proto3 = __webpack_require__(7722);
// EXTERNAL MODULE: ./node_modules/@bufbuild/protobuf/dist/esm/google/protobuf/timestamp_pb.js
var timestamp_pb = __webpack_require__(27251);
;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/platform/websocket/wsevent/v1/ping_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file platform/websocket/wsevent/v1/ping.proto (package platform.websocket.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message platform.websocket.wsevent.v1.PingRequest
 */
const PingRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "platform.websocket.wsevent.v1.PingRequest",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message platform.websocket.wsevent.v1.PingResponse
 */
const PingResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.PingResponse",
  () => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/platform/websocket/wsevent/v1/auth_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file platform/websocket/wsevent/v1/auth.proto (package platform.websocket.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * @generated from message platform.websocket.wsevent.v1.AuthRequest
 */
const AuthRequest = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "platform.websocket.wsevent.v1.AuthRequest",
  () => [
    { no: 1, name: "bearer_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
)));

/**
 * @generated from message platform.websocket.wsevent.v1.AuthResponse
 */
const AuthResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.AuthResponse",
  [],
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/google/type/date_pb.js
// Copyright 2021 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v1.3.0 with parameter "target=js+dts"
// @generated from file google/type/date.proto (package google.type, syntax proto3)
/* eslint-disable */
// @ts-nocheck



/**
 * Represents a whole or partial calendar date, such as a birthday. The time of
 * day and time zone are either specified elsewhere or are insignificant. The
 * date is relative to the Gregorian Calendar. This can represent one of the
 * following:
 *
 * * A full date, with non-zero year, month, and day values
 * * A month and day value, with a zero year, such as an anniversary
 * * A year on its own, with zero month and day values
 * * A year and month value, with a zero day, such as a credit card expiration
 * date
 *
 * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and
 * `google.protobuf.Timestamp`.
 *
 * @generated from message google.type.Date
 */
const date_pb_Date = esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "google.type.Date",
  () => [
    { no: 1, name: "year", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "month", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "day", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/trm/core/portfolio/entity/v2/portfolio_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/trm/core/portfolio/entity/v2/portfolio.proto (package securities.trm.core.portfolio.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck




/**
 * Side defines sides for an order
 *
 * @generated from enum securities.trm.core.portfolio.entity.v2.Side
 */
const Side = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.Side",
  [
    {no: 0, name: "SIDE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SIDE_BUY", localName: "BUY"},
    {no: 2, name: "SIDE_SELL", localName: "SELL"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.PlatformOrderType
 */
const PlatformOrderType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.PlatformOrderType",
  [
    {no: 0, name: "PLATFORM_ORDER_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PLATFORM_ORDER_TYPE_LIMIT_DAY", localName: "LIMIT_DAY"},
    {no: 2, name: "PLATFORM_ORDER_TYPE_MARKET_FAK", localName: "MARKET_FAK"},
    {no: 3, name: "PLATFORM_ORDER_TYPE_FAST_ORDER", localName: "FAST_ORDER"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.LeverageType
 */
const LeverageType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.LeverageType",
  [
    {no: 0, name: "LEVERAGE_TYPE_TRADING_UNSPECIFIED", localName: "TRADING_UNSPECIFIED"},
    {no: 1, name: "LEVERAGE_TYPE_TRADING_BALANCE", localName: "TRADING_BALANCE"},
    {no: 2, name: "LEVERAGE_TYPE_TRADING_LIMIT", localName: "TRADING_LIMIT"},
    {no: 3, name: "LEVERAGE_TYPE_BASIC_LIMIT", localName: "BASIC_LIMIT"},
    {no: 4, name: "LEVERAGE_TYPE_TEMP_LIMIT", localName: "TEMP_LIMIT"},
    {no: 5, name: "LEVERAGE_TYPE_DAY_TRADE", localName: "DAY_TRADE"},
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.SecuritiesKind
 */
const SecuritiesKind = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.SecuritiesKind",
  [
    {no: 0, name: "SECURITIES_KIND_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SECURITIES_KIND_STOCK", localName: "STOCK"},
    {no: 2, name: "SECURITIES_KIND_BOND", localName: "BOND"},
  ],
);

/**
 * PortfolioListSummary contains summary of portfolio list
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary
 */
const PortfolioSummary = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary",
  () => [
    { no: 1, name: "trading", kind: "message", T: PortfolioSummary_Trading },
    { no: 2, name: "amount", kind: "message", T: PortfolioSummary_Amount },
    { no: 3, name: "profit_loss", kind: "message", T: PortfolioSummary_ProfitLoss },
    { no: 4, name: "gain", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "equity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "debt", kind: "message", T: PortfolioSummary_Debt },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.Trading
 */
const PortfolioSummary_Trading = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.Trading",
  () => [
    { no: 1, name: "balance", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_Trading"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.Amount
 */
const PortfolioSummary_Amount = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.Amount",
  () => [
    { no: 1, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "allocated", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "credit_limit", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_Amount"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.ProfitLoss
 */
const PortfolioSummary_ProfitLoss = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.ProfitLoss",
  () => [
    { no: 1, name: "net", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "unrealised", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "realised", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_ProfitLoss"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioSummary.Debt
 */
const PortfolioSummary_Debt = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioSummary.Debt",
  () => [
    { no: 1, name: "ratio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "market_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioSummary_Debt"},
);

/**
 * PortfolioPrice contains price information in portfolio for one symbol
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioPrice
 */
const PortfolioPrice = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioPrice",
  () => [
    { no: 1, name: "latest", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "average", kind: "message", T: PortfolioPrice_Average },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioPrice.Average
 */
const PortfolioPrice_Average = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioPrice.Average",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioPrice_Average"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioQty
 */
const PortfolioQty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioQty",
  () => [
    { no: 1, name: "stock_on_hand", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "available", kind: "message", T: PortfolioQty_Qty },
    { no: 3, name: "balance", kind: "message", T: PortfolioQty_Qty },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioQty.Qty
 */
const PortfolioQty_Qty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioQty.Qty",
  () => [
    { no: 1, name: "lot", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "share", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioQty_Qty"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioAsset
 */
const PortfolioAsset = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioAsset",
  () => [
    { no: 1, name: "unrealised", kind: "message", T: PortfolioAsset_Unrealised },
    { no: 2, name: "amount_invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioAsset.Unrealised
 */
const PortfolioAsset_Unrealised = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioAsset.Unrealised",
  () => [
    { no: 1, name: "market_value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "profit_loss", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "gain", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "PortfolioAsset_Unrealised"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioFlags
 */
const PortfolioFlags = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioFlags",
  () => [
    { no: 1, name: "allow_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "have_smart_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "can_buy", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "can_sell", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * Order defines information on a single order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order
 */
const Order = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "market_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "side", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Side) },
    { no: 7, name: "time", kind: "message", T: Order_Time },
    { no: 8, name: "qty", kind: "message", T: Order_Qty },
    { no: 9, name: "price", kind: "message", T: Order_Price },
    { no: 10, name: "amount", kind: "message", T: Order_Amount },
    { no: 11, name: "action", kind: "message", T: Order_Action },
    { no: 12, name: "smart_order", kind: "message", T: Order_SmartOrder },
    { no: 13, name: "gtc", kind: "message", T: Order_GTC },
    { no: 14, name: "day_trade", kind: "message", T: Order_DayTrade },
    { no: 15, name: "leverage_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(LeverageType) },
    { no: 16, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "securities_kind", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(SecuritiesKind) },
    { no: 18, name: "platform_order_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(PlatformOrderType) },
  ],
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.Order.DayTradeForceSell
 */
const Order_DayTradeForceSell = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.Order.DayTradeForceSell",
  [
    {no: 0, name: "DAY_TRADE_FORCE_SELL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DAY_TRADE_FORCE_SELL_DEBT_RATIO", localName: "DEBT_RATIO"},
    {no: 2, name: "DAY_TRADE_FORCE_SELL_TIME_LIMIT", localName: "TIME_LIMIT"},
  ],
);

/**
 * Amount contains amount-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Amount
 */
const Order_Amount = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Amount",
  () => [
    { no: 1, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "matched", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "matched_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "fee", kind: "message", T: Order_Amount_Fee },
  ],
  {localName: "Order_Amount"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Amount.Fee
 */
const Order_Amount_Fee = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Amount.Fee",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "matched", kind: "message", T: Order_Amount_Fee_Matched },
  ],
  {localName: "Order_Amount_Fee"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Amount.Fee.Matched
 */
const Order_Amount_Fee_Matched = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Amount.Fee.Matched",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "broker", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "exchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "Order_Amount_Fee_Matched"},
);

/**
 * Price contains price-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Price
 */
const Order_Price = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Price",
  () => [
    { no: 1, name: "order", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "average", kind: "message", T: Order_Price_Average },
  ],
  {localName: "Order_Price"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Price.Average
 */
const Order_Price_Average = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Price.Average",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "Order_Price_Average"},
);

/**
 * Time contains time-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Time
 */
const Order_Time = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Time",
  () => [
    { no: 1, name: "order", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 2, name: "open", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 3, name: "match", kind: "message", T: timestamp_pb/* Timestamp */.E },
  ],
  {localName: "Order_Time"},
);

/**
 * Time defines do-able action for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Action
 */
const Order_Action = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Action",
  () => [
    { no: 1, name: "can_amend", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "can_cancel", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "Order_Action"},
);

/**
 * SmartOrder contains information related with smart order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.SmartOrder
 */
const Order_SmartOrder = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.SmartOrder",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trigger_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "config_type", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
  {localName: "Order_SmartOrder"},
);

/**
 * GTC contains information related with GTC order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.GTC
 */
const Order_GTC = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.GTC",
  () => [
    { no: 1, name: "is_gtc", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Order_GTC_GTCStatus) },
  ],
  {localName: "Order_GTC"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.Order.GTC.GTCStatus
 */
const Order_GTC_GTCStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.Order.GTC.GTCStatus",
  [
    {no: 0, name: "GTC_STATUS_UNSPECIFIED"},
    {no: 1, name: "GTC_STATUS_OPEN"},
    {no: 2, name: "GTC_STATUS_MATCH"},
    {no: 3, name: "GTC_STATUS_WITHDRAWN"},
  ],
);

/**
 * Qty contains qty-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.Qty
 */
const Order_Qty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.Qty",
  () => [
    { no: 1, name: "lot_done", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lot_open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "lot_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "Order_Qty"},
);

/**
 * DayTrade contains information related with day trade
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.Order.DayTrade
 */
const Order_DayTrade = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Order.DayTrade",
  () => [
    { no: 1, name: "is_day_trade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "force_sell_event", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(Order_DayTradeForceSell) },
  ],
  {localName: "Order_DayTrade"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail
 */
const OrderDetail = /*@__PURE__*/ (/* unused pure expression or super */ null && (proto3.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail",
  () => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "market_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "side", kind: "enum", T: proto3.getEnumType(Side) },
    { no: 7, name: "time", kind: "message", T: OrderDetail_Time },
    { no: 8, name: "qty", kind: "message", T: OrderDetail_Qty },
    { no: 9, name: "price", kind: "message", T: OrderDetail_Price },
    { no: 10, name: "amount", kind: "message", T: OrderDetail_Amount },
    { no: 11, name: "action", kind: "message", T: OrderDetail_Action },
    { no: 12, name: "smart_order", kind: "message", T: OrderDetail_SmartOrder },
    { no: 13, name: "gtc", kind: "message", T: OrderDetail_GTC },
    { no: 14, name: "day_trade", kind: "message", T: OrderDetail_DayTrade },
    { no: 15, name: "leverage_type", kind: "enum", T: proto3.getEnumType(LeverageType) },
    { no: 16, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "platform_order_type", kind: "enum", T: proto3.getEnumType(PlatformOrderType) },
  ],
)));

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderDetail.DayTradeForceSell
 */
const OrderDetail_DayTradeForceSell = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.DayTradeForceSell",
  [
    {no: 0, name: "DAY_TRADE_FORCE_SELL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DAY_TRADE_FORCE_SELL_DEBT_RATIO", localName: "DEBT_RATIO"},
    {no: 2, name: "DAY_TRADE_FORCE_SELL_TIME_LIMIT", localName: "TIME_LIMIT"},
  ],
);

/**
 * Amount contains amount-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Amount
 */
const OrderDetail_Amount = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Amount",
  () => [
    { no: 1, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "matched", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "matched_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "fee", kind: "message", T: OrderDetail_Amount_Fee },
  ],
  {localName: "OrderDetail_Amount"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee
 */
const OrderDetail_Amount_Fee = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "invested", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "matched", kind: "message", T: OrderDetail_Amount_Fee_Matched },
  ],
  {localName: "OrderDetail_Amount_Fee"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee.Matched
 */
const OrderDetail_Amount_Fee_Matched = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Amount.Fee.Matched",
  () => [
    { no: 1, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "broker", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "exchange", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "OrderDetail_Amount_Fee_Matched"},
);

/**
 * Price contains price-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Price
 */
const OrderDetail_Price = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Price",
  () => [
    { no: 1, name: "order", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "average", kind: "message", T: OrderDetail_Price_Average },
  ],
  {localName: "OrderDetail_Price"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Price.Average
 */
const OrderDetail_Price_Average = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Price.Average",
  () => [
    { no: 1, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "fee", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "portfolio", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "OrderDetail_Price_Average"},
);

/**
 * Time contains time-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Time
 */
const OrderDetail_Time = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Time",
  () => [
    { no: 1, name: "ordered_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 2, name: "opened_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 3, name: "matched_at", kind: "message", T: timestamp_pb/* Timestamp */.E },
  ],
  {localName: "OrderDetail_Time"},
);

/**
 * Time defines do-able action for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Action
 */
const OrderDetail_Action = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Action",
  () => [
    { no: 1, name: "can_amend", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "can_cancel", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "OrderDetail_Action"},
);

/**
 * SmartOrder contains information related with smart order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder
 */
const OrderDetail_SmartOrder = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "trigger_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "config_type", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(OrderDetail_SmartOrder_ConfigPriceType) },
  ],
  {localName: "OrderDetail_SmartOrder"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.ConfigPriceType
 */
const OrderDetail_SmartOrder_ConfigPriceType = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.SmartOrder.ConfigPriceType",
  [
    {no: 0, name: "CONFIG_PRICE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CONFIG_PRICE_TYPE_ABOVE", localName: "ABOVE"},
    {no: 2, name: "CONFIG_PRICE_TYPE_BELOW", localName: "BELOW"},
  ],
);

/**
 * GTC contains information related with GTC order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.GTC
 */
const OrderDetail_GTC = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.GTC",
  () => [
    { no: 1, name: "is_gtc", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "status", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(OrderDetail_GTC_GTCStatus) },
  ],
  {localName: "OrderDetail_GTC"},
);

/**
 * @generated from enum securities.trm.core.portfolio.entity.v2.OrderDetail.GTC.GTCStatus
 */
const OrderDetail_GTC_GTCStatus = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.GTC.GTCStatus",
  [
    {no: 0, name: "GTC_STATUS_UNSPECIFIED"},
    {no: 1, name: "GTC_STATUS_OPEN"},
    {no: 2, name: "GTC_STATUS_MATCH"},
    {no: 3, name: "GTC_STATUS_WITHDRAWN"},
  ],
);

/**
 * Qty contains qty-related information for order
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.Qty
 */
const OrderDetail_Qty = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.Qty",
  () => [
    { no: 1, name: "lot_done", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "lot_open", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "lot_total", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "OrderDetail_Qty"},
);

/**
 * DayTrade contains information related with day trade
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.OrderDetail.DayTrade
 */
const OrderDetail_DayTrade = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.OrderDetail.DayTrade",
  () => [
    { no: 1, name: "is_day_trade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "force_sell_event", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(OrderDetail_DayTradeForceSell) },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "OrderDetail_DayTrade"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.Company
 */
const Company = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.Company",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.ExerciseData
 */
const ExerciseData = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.ExerciseData",
  () => [
    { no: 1, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "date", kind: "message", T: ExerciseData_Date },
    { no: 9, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.ExerciseData.Date
 */
const ExerciseData_Date = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.ExerciseData.Date",
  () => [
    { no: 1, name: "listing", kind: "message", T: date_pb_Date },
    { no: 2, name: "expired", kind: "message", T: date_pb_Date },
    { no: 3, name: "mature", kind: "message", T: date_pb_Date },
    { no: 4, name: "start", kind: "message", T: date_pb_Date },
    { no: 5, name: "end", kind: "message", T: date_pb_Date },
  ],
  {localName: "ExerciseData_Date"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioItem
 */
const PortfolioItem = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioItem",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "company", kind: "message", T: Company },
    { no: 3, name: "qty", kind: "message", T: PortfolioQty },
    { no: 4, name: "price", kind: "message", T: PortfolioPrice },
    { no: 5, name: "asset", kind: "message", T: PortfolioAsset },
    { no: 6, name: "flags", kind: "message", T: PortfolioFlags },
    { no: 7, name: "exercise", kind: "message", T: ExerciseData },
    { no: 8, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioDetail
 */
const PortfolioDetail = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioDetail",
  () => [
    { no: 1, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "company", kind: "message", T: Company },
    { no: 3, name: "qty", kind: "message", T: PortfolioQty },
    { no: 4, name: "price", kind: "message", T: PortfolioPrice },
    { no: 5, name: "asset", kind: "message", T: PortfolioAsset },
    { no: 6, name: "flags", kind: "message", T: PortfolioFlags },
    { no: 7, name: "exercise", kind: "message", T: ExerciseData },
    { no: 8, name: "bond", kind: "message", T: PortfolioDetail_Bond },
    { no: 9, name: "can_create_smart_order", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "is_sharia", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond
 */
const PortfolioDetail_Bond = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond",
  () => [
    { no: 1, name: "coupon", kind: "message", T: PortfolioDetail_Bond_Coupon },
    { no: 2, name: "maturity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "PortfolioDetail_Bond"},
);

/**
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond.Coupon
 */
const PortfolioDetail_Bond_Coupon = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioDetail.Bond.Coupon",
  () => [
    { no: 1, name: "year_rate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "payment_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "distribution", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "PortfolioDetail_Bond_Coupon"},
);

/**
 * PortfolioList defines data on response PortfolioListResponse
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioList
 */
const PortfolioList = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioList",
  () => [
    { no: 1, name: "smart_order_info", kind: "message", T: PortfolioList_SmartOrderInfo },
    { no: 2, name: "summary", kind: "message", T: PortfolioSummary },
    { no: 3, name: "results", kind: "message", T: PortfolioItem, repeated: true },
    { no: 4, name: "day_trade", kind: "message", T: PortfolioItem, repeated: true },
  ],
);

/**
 * PortfolioListInfo contains info of portfolio list
 *
 * @generated from message securities.trm.core.portfolio.entity.v2.PortfolioList.SmartOrderInfo
 */
const PortfolioList_SmartOrderInfo = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.entity.v2.PortfolioList.SmartOrderInfo",
  () => [
    { no: 1, name: "can_create", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "day_trade_can_create", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "PortfolioList_SmartOrderInfo"},
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/securities/trm/core/portfolio/wsevent/v1/securities_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/trm/core/portfolio/wsevent/v1/securities.proto (package securities.trm.core.portfolio.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck




/**
 * WebsocketResponse defines messages when sending response to websocket client
 *
 * @generated from message securities.trm.core.portfolio.wsevent.v1.WebsocketResponse
 */
const WebsocketResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.wsevent.v1.WebsocketResponse",
  () => [
    { no: 1, name: "action", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketResponse_Action) },
    { no: 2, name: "portfolio_summary", kind: "message", T: PortfolioSummary, oneof: "message" },
    { no: 3, name: "portfolio_detail", kind: "message", T: PortfolioDetail, oneof: "message" },
    { no: 4, name: "portfolio_list", kind: "message", T: PortfolioList, oneof: "message" },
    { no: 5, name: "order_detail", kind: "message", T: Order, oneof: "message" },
    { no: 6, name: "order_list", kind: "message", T: WebsocketResponse_OrderList, oneof: "message" },
    { no: 7, name: "portfolio_detail_day_trade", kind: "message", T: PortfolioDetail, oneof: "message" },
  ],
);

/**
 * Action provides various action can applied to websocket message
 *
 * @generated from enum securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.Action
 */
const WebsocketResponse_Action = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.Action",
  [
    {no: 0, name: "ACTION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ACTION_UPSERT", localName: "UPSERT"},
    {no: 2, name: "ACTION_DELETE", localName: "DELETE"},
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.OrderList
 */
const WebsocketResponse_OrderList = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.OrderList",
  () => [
    { no: 1, name: "orders", kind: "message", T: Order, repeated: true },
  ],
  {localName: "WebsocketResponse_OrderList"},
);


;// CONCATENATED MODULE: ./node_modules/@stockbitgroup/protos/platform/websocket/wsevent/v1/websocket_pb.js
// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file platform/websocket/wsevent/v1/websocket.proto (package platform.websocket.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck






/**
 * WebsocketRequest handles request for communicating via websocket
 *
 * @generated from message platform.websocket.wsevent.v1.WebsocketRequest
 */
const WebsocketRequest = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.WebsocketRequest",
  () => [
    { no: 1, name: "requests", kind: "message", T: WebsocketRequest_Request, repeated: true },
  ],
);

/**
 * @generated from message platform.websocket.wsevent.v1.WebsocketRequest.Request
 */
const WebsocketRequest_Request = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.WebsocketRequest.Request",
  () => [
    { no: 1, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "command", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketRequest_Request_Command), oneof: "action" },
    { no: 3, name: "subscribe", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketRequest_Request_Channel), oneof: "action" },
    { no: 4, name: "unsubscribe", kind: "enum", T: esm_proto3/* proto3.getEnumType */.w.getEnumType(WebsocketRequest_Request_Channel), oneof: "action" },
  ],
  {localName: "WebsocketRequest_Request"},
);

/**
 * @generated from enum platform.websocket.wsevent.v1.WebsocketRequest.Request.Command
 */
const WebsocketRequest_Request_Command = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "platform.websocket.wsevent.v1.WebsocketRequest.Request.Command",
  [
    {no: 0, name: "COMMAND_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "COMMAND_PING", localName: "PING"},
    {no: 2, name: "COMMAND_AUTH", localName: "AUTH"},
  ],
);

/**
 * @generated from enum platform.websocket.wsevent.v1.WebsocketRequest.Request.Channel
 */
const WebsocketRequest_Request_Channel = /*@__PURE__*/ esm_proto3/* proto3.makeEnum */.w.makeEnum(
  "platform.websocket.wsevent.v1.WebsocketRequest.Request.Channel",
  [
    {no: 0, name: "CHANNEL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CHANNEL_SECURITIES_LIVE_PORTO", localName: "SECURITIES_LIVE_PORTO"},
  ],
);

/**
 * WebsocketResponse handles response for communicating via websocket
 *
 * @generated from message platform.websocket.wsevent.v1.WebsocketResponse
 */
const websocket_pb_WebsocketResponse = /*@__PURE__*/ esm_proto3/* proto3.makeMessageType */.w.makeMessageType(
  "platform.websocket.wsevent.v1.WebsocketResponse",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: timestamp_pb/* Timestamp */.E },
    { no: 2, name: "ping", kind: "message", T: PingResponse, oneof: "response" },
    { no: 3, name: "auth", kind: "message", T: AuthResponse, oneof: "response" },
    { no: 4, name: "securities", kind: "message", T: WebsocketResponse, oneof: "response" },
  ],
);



/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

}]);